import axios from '@/config/axiosConfig';
import { getRegisterBrokerNotifications, getRegisterBrokerNotificationsCount } from './register-broker-notifications-actions';

export const registerBroker = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();

            return axios.post('/broker-login/add-broker-to-customer-company',
                data,
                { params: {
                    userId: auth?.user?.id,
                    customerId: auth?.customer?.id,
                    companyId: auth?.company?.id
                }
            }).then( async (response) => {
                if (data.requestId) {
                    dispatch(getRegisterBrokerNotifications());
                    dispatch(getRegisterBrokerNotificationsCount());
                }
                return response;
            }).catch((error) => {
                console.error(error);
                console.log('<<error--', error.messege, error.response?.data?.error);
                throw new Error(error.response?.data?.error || error.messege);
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
};

export const registerBrokerToMultipleCompanies = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();

            return axios.post('/broker-login/add-broker-to-customer-multiple-company',
                data,
                { params: {
                    userId: auth?.user?.id,
                    customerId: auth?.customer?.id,
                    companyId: auth?.company?.id
                }
            }).then( async (response) => {
                if (data.requestId) {
                    dispatch(getRegisterBrokerNotifications());
                    dispatch(getRegisterBrokerNotificationsCount());
                }
                return response;
            }).catch((error) => {
                console.error(error);
                console.log('<<error--', error.messege, error.response?.data?.error);
                throw new Error(error.response?.data?.error || error.messege);
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
};